import React from 'react';
import './CloseIcon.scss';


const CloseIcon = ({ close, label, darkMode, dimension, tabIndex, role }) => {
    return (
        <div role="img" aria-label={label}
            className={`closeX ${darkMode ? 'darkBg' : ''}`}
            onClick={close}
            onKeyPress={close}
            style={{ width: dimension, height: dimension}}
            tabIndex={tabIndex}
            role={role}></div>
    );
}

export default CloseIcon;